const ALERT_TYPES = {
  error: 'error',
  success: 'success',
};

export default ALERT_TYPES;
